import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/warning-orange-icon.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_2 = { class: "tw-p-[40px] modal-create-org" }
const _hoisted_3 = { class: "manage-role tw-bg-white" }
const _hoisted_4 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-justify-start md:tw-justify-between" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-font-semibold tw-flex-1 tw-text-xl" }
const _hoisted_6 = { class: "input-base-form-input tw-text-[#B7B7B7]" }
const _hoisted_7 = { class: "tw-p-[15px] tw-w-[247px]" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-text-[#211f58] tw-font-[Poppins] tw-text-[12px] tw-font-medium tw-leading-[100%] tw-not-italic" }
const _hoisted_9 = { class: "tw-mt-[10px] tw-text-[11px] tw-font-[400] tw-text-[#878787] tw-font-[Poppins]" }
const _hoisted_10 = { class: "tw-flex tw-justify-between" }
const _hoisted_11 = {
  key: 0,
  class: "tw-h-[14px] tw-w-[14px] tw-mr-[10px]",
  src: "/img/lock1_icon.svg",
  alt: "icon"
}
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass('tw-text-[#231F20]')
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  class: "right-arrow",
  src: "/img/blue_right_arrow_icon.svg"
}, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-item-center tw-mr-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "divider tw-mt-[35px] tw-mb-[35px]" }, null, -1)
const _hoisted_17 = { class: "tw-flex tw-justify-end tw-mt-[40px]" }

import { Ref, onMounted, computed, reactive, ref, watch, PropType } from "vue";
import useVuelidate from "@vuelidate/core";
import {
  required,
  helpers,
  minLength,
  maxLength,
  alphaNum,
} from "@vuelidate/validators";
import { tlDomain } from "@/utils/validationRules";

import Modal from "../common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import {
  IsEmailValidWhileTyping,
  IsSpecialCharDomainValid,
  IsSpecialCharEmailValid,
  getComponentUiText,
} from "@/utils/utilities";
import CustomSwitchCheckbox from "@/components/common/customSwitchCheckbox.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseMultiDropDown from "@/components/common/form/baseMultiDropDown.vue";
import BaseForm from "@/components/common/form/baseForm.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  IOrgCreateRequest,
  IOrgVerificationCreate,
  IOrgVerificationCreateOrg,
} from "@/interfaces/orgInterfaces";
import {
  fetchOrgAccessType,
  postOrgCreate,
  postVerificationRequestOrgCreate,
  getOrgDomainsInvalid,
  getOrgMembersAddable,
  putVerificationRequestOrg,
} from "@/services/org";
import store from "@/store";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import get from "lodash/get";
import commonServices from "@/services/common/commonServices";
import utilities from "@/utils/utilities";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { MODAL_NAME, requestAccessDetailModalType } from "@/utils/constants";
import { email } from "@vuelidate/validators";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { IModalMessage } from "@/interfaces/common/common";
import ButtonLoading from "../common/buttonLoading.vue";

const DEFAULT_MAX_WIDTH_MODAL = 65;

export default /*#__PURE__*/_defineComponent({
  __name: 'createOrgModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  type: {
    type: String as PropType<keyof typeof requestAccessDetailModalType>,
    required: false,
    default: requestAccessDetailModalType.createRequest,
  },
  data: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  orgData: {
    type: Object as PropType<any>,
    required: false,
    default: () => ({}),
  },
  hideOverlay: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ["update:show", "update:domain"],
  setup(__props, { emit }) {

const props = __props;

const commonService = new commonServices();

const isCreateOrg = props.type === requestAccessDetailModalType.createOrg;
const isShowResendTokenModal = ref(false);
let messageSuccess = getComponentUiText(
  "app-settings-organisation-manage-toast-org-created-1",
);

let showRef = ref(props.show);
let notInfoVisible = ref(true);
let invalidDomain: Ref<string[]> = ref([]);
const orgToOrgTypeIdOptions: Ref<IDropDownData[]> = ref([]);
const nameCodeBlurred: Ref<boolean> = ref(false);

const lockStatusOptions: IDropDownData[] = [
  {
    id: true,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
    ),
    iconSrc: "/img/lock1_icon.svg",
  },
  {
    id: false,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
    ),
  },
];

const validateForDomain = (text: string) => {
  return !invalidDomain.value.some((domain) => text.includes(domain));
};

const initialForm = computed<IOrgCreateRequest>(() => {
  return {
    orgVerifyId: props.orgData?.id || "",
    emailDomain: props.orgData?.domain || "",
    orgContact: props.orgData?.email || "",
    makeSuperAdmin: isCreateOrg ? null : !!props.orgData?.makeSuperAdmin,
    nameCode: props.orgData?.nameCode || "",
    orgToOrgTypeId: "",
    isLocked: true,
    superAdminIds: [],
    nameLegal: props.orgData?.nameLegal || "",
    nameDisplay: props.orgData?.nameShort || "",
    requireMFA: false,
  };
});

const form = reactive<any>({ ...initialForm.value });

onMounted(() => {
  form.value = { ...initialForm.value };
});

watch(
  () => initialForm,
  () => {
    form.value = { ...initialForm.value };
  },
);

const rulesOrg = {
  emailDomain: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    domain: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-email-domain-invalid-1",
        ),
      tlDomain,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharDomainValid,
    ),
    invalid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-email-domain-invalid-2",
          false,
          {
            moreDetails: `<a class='tw-underline' href='#'>${getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-email-domain-more-details-1",
            )}</span>`,
          },
        ),
      validateForDomain,
    ),
  },
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      alphaNum,
    ),
  },
  orgToOrgTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  isLocked: {},
  superAdminIds: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: minLength(1),
  },
};

const rulesRequest = {
  orgContact: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  makeSuperAdmin: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      alphaNum,
    ),
  },
};

const fetchOrgDomainsInvalid = async () => {
  try {
    if (invalidDomain.value?.length > 0) return invalidDomain.value;
    const res = await getOrgDomainsInvalid();
    if (res && res.data && res.data.data) return res.data.data;
    else return [];
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgDomainsInvalid);
    }
  }
};

const updateValidateRules = async () => {
  invalidDomain.value = isCreateOrg ? await fetchOrgDomainsInvalid() : [];
};

let v$ = isCreateOrg
  ? useVuelidate(rulesOrg, form)
  : useVuelidate(rulesRequest, form);
const currentOrg = computed(() => store.state.Org.currentOrg);
const superAdminUsers: Ref<IDropDownData[]> = ref([]);

watch(
  () => form.nameCode,
  (value) => {
    if (!utilities.regexMatch(/^[a-z0-9]+$/i, value)) {
      nameCodeBlurred.value = true;
    } else {
      nameCodeBlurred.value = false;
    }
  },
);

const isCallApi = ref(false);

const onSubmit = async () => {
  await v$.value.$validate();
  nameCodeBlurred.value = true;
  if (v$.value.$invalid) return;

  try {
    isCallApi.value = true;
    switch (props.type) {
      case requestAccessDetailModalType.createOrg: {
        await createOrg();
        break;
      }
      case requestAccessDetailModalType.createRequest: {
        await createRequest();
        break;
      }
      case requestAccessDetailModalType.editRequest: {
        if (form.orgContact === props.orgData?.email) {
          openResendTokenModal(form);
        } else {
          editRequest(true);
        }
        break;
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  } finally {
    isCallApi.value = false;
  }
};

const openResendTokenModal = (data: any) => {
  isShowResendTokenModal.value = true;
  const emitData: IModalMessage = {
    component: MODAL_NAME.RESEND_TOKEN_MODAL,
    properties: {
      isMoreInfoModal: true,
    },
    events: {
      "update:close": () => {
        isShowResendTokenModal.value = false;
      },
      "update:resend": () => {
        editRequest(true);
      },
      "update:only": () => {
        editRequest(false);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const editRequest = async (sendNewToken: boolean) => {
  try {
    const formData = {
      email: form.orgContact,
      nameCode: form.nameCode,
      makeSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameShort: form.nameDisplay,
      sendNewToken,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    if (props.orgData.id) {
      const formResponse = await putVerificationRequestOrg(
        props.orgData.id,
        formSubmit,
      );

      if (formResponse.data?.data) {
        handleCloseModal();
        if (sendNewToken) {
          EventEmitter.emit(
            EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
            form.nameDisplay || form.nameCode,
          );
          onShowToast(
            getComponentUiText(
              "app-settings-org-manage-toast-org-request-verification-created-1",
            ),
            ToastVariant.SUCCESS,
          );
        } else {
          store.dispatch("Org/fetchOrgListVerify");
          onShowToast(
            getComponentUiText(
              "app-settings-organisation-manage-toast-org-request-verification-edited-1",
            ),
            ToastVariant.SUCCESS,
          );
        }
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.editRequestVerification);
    }
  }
};

const createRequest = async () => {
  try {
    const formData: IOrgVerificationCreate = {
      email: form.orgContact,
      nameCode: form.nameCode,
      makeSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameShort: form.nameDisplay,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    const formResponse = await postVerificationRequestOrgCreate(formSubmit);

    if (formResponse.data?.data) {
      onShowToast(
        getComponentUiText(
          "app-settings-org-manage-toast-org-request-verification-created-1",
        ),
        ToastVariant.SUCCESS,
      );
      handleCloseModal();
      EventEmitter.emit(
        EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
        form.nameDisplay || form.nameCode,
      );
      store.dispatch("Org/fetchOrgListVerify");
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.createRequestVerification);
    }
  }
};

const createOrg = async () => {
  try {
    const formData: IOrgVerificationCreateOrg = {
      orgVerifyId: form.orgVerifyId,
      orgToOrgTypeId: form.orgToOrgTypeId,
      nameCode: form.nameCode,
      makeVerifiedEmailSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameDisplay: form.nameDisplay,
      isLocked: form.isLocked,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    const formResponse = await postOrgCreate(formSubmit);

    if (formResponse.data?.data) {
      onShowToast(messageSuccess, ToastVariant.SUCCESS);
      store.dispatch("Org/fetchOrgList");
      EventEmitter.emit(EmitterEvents.REFRESH_ORG_DATA);
      handleCloseModal();
      EventEmitter.emit(
        EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
        form.nameDisplay || form.nameCode,
      );
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  }
};

const openVerifyOrgModal = (data: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.VERIFY_ORG,
    properties: {
      orgName: data.nameShort ?? "",
      secretKey: data.secretKey,
    },
    events: {
      "close:modal": () => {
        store.dispatch("Org/fetchOrgList");
        EventEmitter.emit(EmitterEvents.REFRESH_ORG_DATA);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
  },
);

const initial = () => {
  notInfoVisible.value = true;
};

const handleLockStatus = () => {
  const isShowLockStatus =
    orgToOrgTypeIdOptions.value.find((org) => org.id === form.orgToOrgTypeId)
      ?.isLockable === true;
  if (isShowLockStatus) return true;
  else return false;
};

onMounted(() => {
  updateValidateRules();
});

const clearData = () => {
  for (const key in form) {
    if (Array.isArray(form[key])) {
      form[key].splice(0); // Clear the array content while maintaining reference
    } else {
      form[key] = initialForm[key];
    }
  }

  v$.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

const fetchRoleMembersData = async () => {
  try {
    const responseData = await getOrgMembersAddable(currentOrg.value.id); //l
    const usersResponse = get(responseData, "data.data", []);
    superAdminUsers.value = usersResponse.map((user: any) => ({
      name: `${user.firstName} ${user.lastName}`,
      id: user.userId,
    }));
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const fetchOrgToOrgTypeId = async () => {
  try {
    const orgToOrgTypeIdResponse = await fetchOrgAccessType();
    if (orgToOrgTypeIdResponse?.data?.data) {
      // only isLockable true relationship can be selected
      orgToOrgTypeIdOptions.value = orgToOrgTypeIdResponse.data.data
        .filter((relationship) => relationship.isLockable)
        .map((relationship) => ({
          name: relationship.name,
          id: relationship.id,
          isLockable: relationship.isLockable,
        }));
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgAccessTypes);
    }
  }
};

const getFormData = async () => {
  if (isCreateOrg) {
    fetchOrgToOrgTypeId();
    fetchRoleMembersData();
  }
};

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue?.id && newValue?.id !== oldValue?.id) {
      getFormData();
    }
  },
  { deep: true, immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%]",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    value: form,
    "close-on-esc": !isShowResendTokenModal.value,
    "is-hide-overlay": __props.hideOverlay,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: 
        __props.type === _unref(requestAccessDetailModalType).editRequest
          ? _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-edit-org-modal-title-1',
            )
          : _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-create-org-modal-title-1',
            )
      ,
        "class-name": "!tw-text-[18px]",
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseForm, {
          show: _unref(showRef),
          "enter-event": true,
          "onOn:submit": onSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                  "app-settings-organisation-manage-access-create-org-modal-title-2",
                )), 1)
              ]),
              _createElementVNode("div", null, [
                isCreateOrg
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 0,
                      modelValue: form.emailDomain,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.emailDomain) = $event)),
                      validation: _unref(v$).emailDomain,
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-email-domain-prompt-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)('app-settings-organisation-domain-title-1')
              ,
                      onBlur: _cache[1] || (_cache[1] = 
                () => {
                  _unref(v$).emailDomain.$validate();
                }
              )
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(form.emailDomain), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label"]))
                  : (_openBlock(), _createBlock(BaseInput, {
                      key: 1,
                      modelValue: form.orgContact,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.orgContact) = $event)),
                      validation: _unref(v$).orgContact,
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-org-contact-prompt-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-org-contact-1',
                )
              ,
                      "label-tooltip": 
                _unref(getComponentUiText)(
                  'app-settings-organisation-contact-label-tooltip-1',
                )
              ,
                      onBlur: _cache[3] || (_cache[3] = 
                () => {
                  _unref(v$).orgContact.$validate();
                }
              )
                    }, {
                      rightTitle: _withCtx(() => [
                        _createVNode(ButtonShowDuplicateAssessment, {
                          "id-popover": 'popover-btn-show-duplicate-create-org-modal',
                          "custom-class": 'tw-max-w-[470px] ',
                          classes: '!tw-leading-[unset] tw-ml-[6px]'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                          "app-settings-organisation-manage-access-create-org-modal-org-contact-1",
                        )), 1),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)(
                          "app-settings-organisation-contact-description-tooltip-1",
                        )), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label", "label-tooltip"])),
                (__props.type !== _unref(requestAccessDetailModalType).createOrg)
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 2,
                      modelValue: form.makeSuperAdmin,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.makeSuperAdmin) = $event)),
                      validation: _unref(v$).makeSuperAdmin,
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-create-request-make-contact-title-1',
                )
              
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomSwitchCheckbox, {
                          modelValue: form.makeSuperAdmin,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.makeSuperAdmin) = $event)),
                          checked: form.makeSuperAdmin,
                          class: "tw-mb-0",
                          "class-name": "grey-slider",
                          "onUpdate:checkbox": _cache[5] || (_cache[5] = (value) => (form.makeSuperAdmin = value))
                        }, null, 8, ["modelValue", "checked"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label"]))
                  : _createCommentVNode("", true),
                _createVNode(BaseInput, {
                  modelValue: form.nameCode,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.nameCode) = $event)),
                  validation: 
                form.nameCode?.length >= 4 || nameCodeBlurred.value
                  ? _unref(v$).nameCode
                  : { required: () => {}, $touch: () => {}, $reset: () => {} }
              ,
                  placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-prompt-1',
                )
              ,
                  label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-1',
                )
              ,
                  "label-tooltip": 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-tooltip-1',
                )
              ,
                  onBlur: _cache[8] || (_cache[8] = 
                () => {
                  _unref(v$).nameCode.$validate();
                  nameCodeBlurred.value = true;
                }
              ),
                  onFocus: _cache[9] || (_cache[9] = () => (nameCodeBlurred.value = false))
                }, null, 8, ["modelValue", "validation", "placeholder", "label", "label-tooltip"]),
                isCreateOrg
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 3,
                      id: "orgToOrgTypeId",
                      modelValue: form.orgToOrgTypeId,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.orgToOrgTypeId) = $event)),
                      validation: _unref(v$).orgToOrgTypeId,
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-org-relationship-prompt-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-org-relationship-1',
                )
              
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BaseDropDown, {
                          id: 'domain',
                          modelValue: form.orgToOrgTypeId,
                          "onUpdate:modelValue": [
                            _cache[10] || (_cache[10] = ($event: any) => ((form.orgToOrgTypeId) = $event)),
                            _cache[11] || (_cache[11] = () => (form.isLocked = true))
                          ],
                          data: orgToOrgTypeIdOptions.value,
                          validation: _unref(v$).orgToOrgTypeId,
                          "class-name": 'gray-dropdown-container tw-h-[58px]',
                          placeholder: 
                  _unref(getComponentUiText)(
                    'app-settings-organisation-manage-access-create-org-modal-org-relationship-prompt-1',
                  )
                
                        }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label"]))
                  : _createCommentVNode("", true),
                (handleLockStatus())
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 4,
                      id: "lock-status",
                      modelValue: form.isLocked,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.isLocked) = $event)),
                      validation: _unref(v$).isLocked,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-modals-label-lock-status-1',
                )
              ,
                      "label-tooltip": 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-offer-modal-description-lock-status-1',
                )
              ,
                      "validate-on-blur": true
                    }, {
                      feedback: _withCtx(() => [
                        (form.isLocked === false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-organisation-manage-access-modals-warning-lock-status-1",
                    )), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(BaseDropDown, {
                          id: 'isLocked',
                          modelValue: form.isLocked,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.isLocked) = $event)),
                          data: lockStatusOptions,
                          validation: _unref(v$).isLocked,
                          "class-name": 'gray-dropdown-container tw-h-[58px]',
                          placeholder: 
                  _unref(getComponentUiText)(
                    'app-settings-organisation-manage-access-modals-prompt-lock-status-1',
                  )
                
                        }, {
                          "button-content": _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", null, [
                                (form.isLocked)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(lockStatusOptions.find((m) => m.id === form.isLocked)
                          ?.name), 1)
                              ]),
                              _hoisted_13
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "validation", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "label", "label-tooltip"]))
                  : _createCommentVNode("", true),
                isCreateOrg
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 5,
                      id: "'superAdminUser'",
                      modelValue: form.superAdminIds,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.superAdminIds) = $event)),
                      validation: _unref(v$).superAdminIds,
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-super-admin-users-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-super-admin-users-1',
                )
              
                    }, {
                      default: _withCtx(() => [
                        _createVNode(BaseMultiDropDown, {
                          id: 'superAdminMultiDropDown',
                          modelValue: form.superAdminIds,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.superAdminIds) = $event)),
                          data: superAdminUsers.value,
                          validation: _unref(v$).superAdminIds,
                          "class-name": 'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]',
                          placeholder: 
                  _unref(getComponentUiText)(
                    'app-settings-organisation-manage-access-create-org-modal-super-admin-users-prompt-1',
                  )
                
                        }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation", "placeholder", "label"]))
                  : _createCommentVNode("", true),
                _hoisted_16,
                _createVNode(BaseInput, {
                  modelValue: form.nameLegal,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.nameLegal) = $event)),
                  validation: _unref(v$).nameLegal,
                  placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-legal-name-prompt-1',
                )
              ,
                  label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-legal-name-prompt-1',
                )
              
                }, null, 8, ["modelValue", "validation", "placeholder", "label"]),
                _createVNode(BaseInput, {
                  modelValue: form.nameDisplay,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.nameDisplay) = $event)),
                  validation: _unref(v$).nameDisplay,
                  placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-prompt-1',
                )
              ,
                  label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-1',
                )
              ,
                  "label-tooltip": 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-tooltip-1',
                )
              
                }, null, 8, ["modelValue", "validation", "placeholder", "label", "label-tooltip"]),
                isCreateOrg
                  ? (_openBlock(), _createBlock(BaseInput, {
                      key: 6,
                      modelValue: form.requireMFA,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.requireMFA) = $event)),
                      placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              ,
                      label: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomSwitchCheckbox, {
                          modelValue: form.requireMFA,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.requireMFA) = $event)),
                          checked: form.requireMFA,
                          class: "tw-mb-0",
                          "class-name": "grey-slider",
                          "onUpdate:checkbox": _cache[20] || (_cache[20] = (value) => (form.requireMFA = value))
                        }, null, 8, ["modelValue", "checked"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(ButtonLoading, {
                class: _normalizeClass(["create-organisation-button !tw-items-center tw-bg-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]", `${isCallApi.value ? 'tw-p-0' : 'tw-py-[11px] tw-px-[18px]'}`]),
                "data-cy": "header-save-change-button",
                title: 
              _unref(getComponentUiText)(
                isCreateOrg
                  ? 'app-settings-organisation-manage-access-create-org-modal-submit-button-1'
                  : __props.type === _unref(requestAccessDetailModalType).createRequest
                    ? 'app-settings-organisation-manage-access-create-org-modal-button-title-request-verification-1'
                    : 'app-settings-organisation-manage-access-create-org-modal-button-title-update-request-1',
              )
            ,
                "is-loading": isCallApi.value
              }, null, 8, ["class", "title", "is-loading"])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "value", "close-on-esc", "is-hide-overlay"]))
}
}

})